import Q from "q";
const geoIp = (() => {
  const svc = {
    helpers: {
      httpGet: () => {
        let defer = Q.defer();
        let appLocale = { country: undefined, state: "" };
        //wrap in try/catch in case they have a plugin that blocks geoip lookup
        try {
          window.geoip2.city(
            function(data) {
              appLocale = {
                country: data.country.iso_code,
                state: data.subdivisions[0].iso_code
              };
              defer.resolve(appLocale);
            },
            function(err) {
              defer.resolve(appLocale);
            }
          );
        } catch (e) {
          defer.resolve(appLocale);
        }

        return defer.promise;
      }
    }
  };

  return {
    get: () => {
      let defer = Q.defer();
      svc.helpers.httpGet().done(appLocale => {
        defer.resolve(appLocale);
      });
      return defer.promise;
    }
  };
})();
export default geoIp;



// WEBPACK FOOTER //
// ./src/services/http/geoIp.js